import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref } from "vue"

const _hoisted_1 = { class: "rounded-catering-md border border-catering-cream-300 bg-catering-cream-50 p-3 text-sm text-catering-ink-900 shadow-catering-xs" }
const _hoisted_2 = { class: "mb-2 text-xs font-semibold uppercase tracking-wide text-catering-honey-600" }
const _hoisted_3 = {
  key: 0,
  class: "space-y-2"
}
const _hoisted_4 = { class: "flex items-baseline justify-between gap-2" }
const _hoisted_5 = { class: "font-semibold text-catering-ink-900" }
const _hoisted_6 = {
  key: 0,
  class: "shrink-0 tabular-nums text-catering-ink-700"
}
const _hoisted_7 = {
  key: 1,
  class: "space-y-2"
}
const _hoisted_8 = { class: "flex items-baseline justify-between gap-2" }
const _hoisted_9 = { class: "text-[15px] font-semibold text-catering-ink-900" }
const _hoisted_10 = {
  key: 0,
  class: "shrink-0 rounded bg-catering-honey-100 px-1.5 py-0.5 text-[11px] font-medium text-catering-honey-600"
}
const _hoisted_11 = { class: "mt-2 space-y-1 text-xs" }
const _hoisted_12 = {
  key: 0,
  class: "flex justify-between gap-3"
}
const _hoisted_13 = { class: "text-right text-catering-ink-700" }
const _hoisted_14 = {
  key: 1,
  class: "flex justify-between gap-3"
}
const _hoisted_15 = { class: "text-right text-catering-ink-700" }
const _hoisted_16 = {
  key: 2,
  class: "flex justify-between gap-3"
}
const _hoisted_17 = { class: "text-right text-catering-ink-700" }
const _hoisted_18 = {
  key: 0,
  class: "mt-2 flex flex-wrap gap-1"
}
const _hoisted_19 = {
  key: 0,
  class: "rounded bg-catering-cream-300 px-1.5 py-0.5 text-[11px] font-medium text-catering-ink-600"
}
const _hoisted_20 = {
  key: 1,
  class: "rounded bg-catering-cream-300 px-1.5 py-0.5 text-[11px] font-medium text-catering-ink-600"
}

import { formatBotDate, formatBotDateTime, formatBotTime, isBotDate } from '@/helpers/botDateFormat'


export default {
  __name: 'BotSlotSchedule',
  props: { block: { type: Object, required: true } },
  setup(__props) {



function windowHeadline(w) {
  if (isBotDate(w.date)) return formatBotDate(w.date)
  return [w.day_of_week, w.date].filter(Boolean).join(', ')
}

function arrivalRange(w) {
  const start = formatBotTime(w.arrival_start)
  const end = formatBotTime(w.arrival_end)
  if (start && end) return `${start}–${end}`
  return start || end || ''
}

return (_ctx, _cache) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("p", _hoisted_2, _toDisplayString(__props.block.windows ? 'Upcoming slots' : 'Slot schedule'), 1),
    (__props.block.windows)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.block.windows || [], (w, i) => {
            return (_openBlock(), _createElementBlock("div", {
              key: i,
              class: "rounded-catering-md border border-catering-cream-300 bg-catering-cream-100 px-3 py-2"
            }, [
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("p", _hoisted_5, _toDisplayString(windowHeadline(w)), 1),
                (arrivalRange(w))
                  ? (_openBlock(), _createElementBlock("p", _hoisted_6, _toDisplayString(arrivalRange(w)), 1))
                  : _createCommentVNode("", true)
              ])
            ]))
          }), 128))
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_7, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.block.slots || [], (s, i) => {
            return (_openBlock(), _createElementBlock("div", {
              key: i,
              class: "rounded-catering-md border border-catering-cream-300 bg-catering-cream-100 px-3 py-2.5"
            }, [
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("p", _hoisted_9, _toDisplayString(_unref(formatBotDate)(s.production_date)), 1),
                (s.capacity != null)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_10, " Capacity " + _toDisplayString(s.capacity), 1))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("dl", _hoisted_11, [
                (s.order_cutoff)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                      _cache[0] || (_cache[0] = _createElementVNode("dt", { class: "text-catering-ink-500" }, "Order cutoff", -1)),
                      _createElementVNode("dd", _hoisted_13, _toDisplayString(_unref(formatBotDateTime)(s.order_cutoff)), 1)
                    ]))
                  : _createCommentVNode("", true),
                (s.order_start)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                      _cache[1] || (_cache[1] = _createElementVNode("dt", { class: "text-catering-ink-500" }, "Orders open", -1)),
                      _createElementVNode("dd", _hoisted_15, _toDisplayString(_unref(formatBotDateTime)(s.order_start)), 1)
                    ]))
                  : _createCommentVNode("", true),
                (s.arrival_window)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                      _cache[2] || (_cache[2] = _createElementVNode("dt", { class: "text-catering-ink-500" }, "Arrival", -1)),
                      _createElementVNode("dd", _hoisted_17, _toDisplayString(s.arrival_window), 1)
                    ]))
                  : _createCommentVNode("", true)
              ]),
              (s.recurrence || s.horizon)
                ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                    (s.recurrence)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_19, " Recurs " + _toDisplayString(s.recurrence), 1))
                      : _createCommentVNode("", true),
                    (s.horizon)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_20, _toDisplayString(s.horizon) + " ahead ", 1))
                      : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true)
            ]))
          }), 128))
        ]))
  ]))
}
}

}